import { useState } from 'react';

import useMessage from '@/src/compat/useMessage';

import { EventListenerType } from './enums/EventListenerEnum';

export const useSenderScoreWithPostMessage = (
  senderScore?: number
): [number | undefined, undefined] => {
  const [scoring, setScore] = useState(senderScore || 0);
  useMessage(EventListenerType.Scoring, (_, event) => {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    setScore(Math.round((event.data.value[0].score + Number.EPSILON) * 10) / 10);
  });
  return [scoring, undefined];
};
